import FormikInputText from "common/components/FormikFields/FormikInputText"
import { useTranslation } from "react-i18next"

const FormEmailPhone = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className='mb-2 crear-contacto__subtitle'>
        {" "}
        {t("contactos.crear.labelContactForm")}
      </div>

      <div className='text-left p-field'>
        <label> {t("contactos.crear.labelMail")}</label>

        <FormikInputText
          className='w-100'
          noSpaces
          id='email'
          name='email'
        />
      </div>

      <div className='text-left p-field'>
        <label> {t("contactos.crear.labelTlf")} </label>

        <FormikInputText
          className='w-100'
          noSpaces
          id='telefono'
          name='telefono'
        />
      </div>
    </>
  )
}

export default FormEmailPhone
